<template>
  <div class="box">
    <div class="addReward">
    <van-form @submit="onSubmit">
        <van-cell-group>
          <!-- <van-field input-align="right" required :rules="[{ required:true, message: '请输入' }]" v-model="baseinfo.empno" placeholder="请输入工号" label="工号"/> -->
        </van-cell-group>
        <van-cell-group>
          <van-field input-align="right" required :rules="[{ required:true, message: '请输入' }]" readonly clickable  label-width="100" :value="baseinfo.rewardtype" label="奖惩类型" placeholder="请输入奖惩类型" @click="showRewardtype = true,getDict('rewardtype')"/>
          <van-popup v-model="showRewardtype" position="bottom">
            <van-picker
              show-toolbar
              :columns="columns"
              @confirm="onConRewardtype"
              @cancel="showRewardtype = false"
            />
          </van-popup>
        </van-cell-group>
        <van-cell-group>
          <van-field input-align="right" required :rules="[{ required:true, message: '请输入' }]" v-model="baseinfo.rewardname" placeholder="请输入奖惩名称" label="奖惩名称"/>
        </van-cell-group>
        <van-cell-group>
          <van-field input-align="right" required :rules="[{ required:true, message: '请输入' }]" type="date" v-model="baseinfo.rewarddate" placeholder="请输入奖惩时间" label="奖惩时间"/>
        </van-cell-group>
        <van-cell-group>
          <van-field input-align="right" required :rules="[{ required:true, message: '请输入' }]" v-model="baseinfo.rewardorg" placeholder="请输入组织" label="组织"/>
        </van-cell-group>
        <van-cell-group>
          <van-field input-align="right" required :rules="[{ required:true, message: '请输入' }]" v-model="baseinfo.rewardreason" placeholder="请输入原因" label="原因"/>
        </van-cell-group>
        <van-cell-group>
          <van-field input-align="right" required :rules="[{ required:true, message: '请输入' }]" v-model="baseinfo.rewardcontent" placeholder="请输入描述" label="描述"/>
        </van-cell-group>
        <van-cell-group>
          <van-field input-align="right" v-model="baseinfo.remark" placeholder="请输入备注" label="备注"/>
        </van-cell-group>
        <div class="btnBox">
            <van-button round block type="info" native-type="submit" class="btn">确认</van-button>
        </div>
    </van-form>
    <div class="footer">
      <van-button round block class="btnClo" @click="toInfo">取消</van-button>
    </div>
  </div>
  </div>
</template>

<script>
import api from '@/apis'
import moment from 'moment'
export default {
  name: "addReward",
  data(){
    return {
      baseinfo:{
        empno: "", //员工工号
        rewardtype: "", //奖惩类型
        rewardname: "", //奖惩名称
        rewarddate: "", //奖惩时间
        rewardorg: "", //组织
        rewardreason: "", //原因
        rewardcontent: "", //描述
        remark: "", //备注
      },
      showRewardtype:false,
      columns: [],
      itemId:[],
      id:''
    }
  },
  methods: {
    //获取奖惩类型列表
    getDict(type){
      api.setGetDicts({type}).then((data)=>{
          this.itemId = data.data
          let items = data.data
          this.columns = []
          items.forEach(item=>{
            this.columns.push(item.title)
          })
      })
    },
    //选择奖惩类型
    onConRewardtype(value){
      const str = this.itemId.find(item=>{
        return item.title === value
      })
      this.id = str.id
      this.baseinfo.rewardtype = value
      
      this.showRewardtype = false
    },
    // 提交表单
    onSubmit(){
      let obj = {
        ...this.baseinfo,
        rewarddate:moment(this.baseinfo.rewarddate).format('YYYY-MM-DD'),
        rewardtype:this.id,
        table:'euBgrewardList',
        saveType:'1',
        empid:this.$store.state.userInfo.empID,
        empno:this.$store.state.userInfo.empNo,
      }
      api.setSaveEmpInfo(obj).then(()=>{
        this.$toast('添加成功');
        this.$router.push({
        path:'/mobile/info',
        query:{
          type:'add'
        }
        })
      })
    },
    //跳转
    toInfo(){
      this.$router.push({
        path:'/mobile/info',
        query:{
          type:'no'
        }
      })
    }
  },
};
</script>
<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  .addReward {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  .addReward {
    width: 276px * $zoom;
  }
}
.box{
  display: flex;
  justify-content: center;
}
::v-deep .van-picker__toolbar{
    height: 40px * $zoom;
    .van-picker__cancel{
      font-size: 0.42667rem;
    }
    .van-picker__confirm{
      font-size: 16px * $zoom;
    }
  }
  ::v-deep .van-ellipsis{
    font-size: 8px * $zoom;
  }
.addReward {
  font-size: 16px * $zoom;
  min-height: 100vh;
  background: #f4f5f8;
  position: relative;
}
.fromBox{
    height: 90vh;
}
.btnBox{
    width: 50%;
    position: absolute;
    bottom: 20px * $zoom;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 10px * $zoom 20px * $zoom;
    margin-left: 50%;
}
.btn {
  width: 80px * $zoom;
  font-size: 12pt;
  padding: 5px * $zoom;
}
.footer{
  width: 50%;
  position: absolute;
  bottom: 20px * $zoom;
  display: flex;
  justify-content: flex-end;
  padding: 10px * $zoom 20px * $zoom;
}
.btnClo{
  width: 80px * $zoom;
  font-size: 12pt;
  padding: 5px * $zoom;
  border: none;
}
</style>
